import Cookies from 'universal-cookie';
import { AxiosResponse } from 'axios';
import { Auth as TPAuth } from '@trustpilot/ecommscript-integrationappauth/external-authentication';

const cookie = new Cookies();

export class Auth extends TPAuth {

  public static resetTokenIfUnauthorized(response?: AxiosResponse) {
    if (response && [401, 403].includes(response.status)) {
      Auth.removeTokens(process.env.REACT_APP_CookiesDomain!);
      window.location.reload();
    }
  }

  // TODO revisit or change access override from @trustpilot/ecommscript-integrationappauth
  public static removeTokens(domain: string) {
    Auth.removeCookie('tp-b2b-access-token', { path: '/', domain, sameSite: 'none', secure: true });
    Auth.removeCookie('tp-refresh-token', { path: '/', domain, sameSite: 'none', secure: true });
  }

  // TODO revisit or change access override from @trustpilot/ecommscript-integrationappauth
  private static removeCookie(name: string, options: object = {}) {
        cookie.remove(name, options);
  }

}
